import axios, { AxiosResponse } from "axios";

const instance = axios.create();



var retry = true;
instance.defaults.withCredentials = true;
instance.interceptors.response.use(
    (response) => {    
        return response;
    },
    (error) => {
        if (!fixtureMode) {
            if (error.response.status === 401) {
                if (retry) {
                    var token = instance.post("api/auth/token");
                    retry = false;
                } else {
                    localStorage.removeItem("userRole");
                    window.location.assign(
                        "api/auth/login?returnPath=" +
                            encodeURIComponent(portalUriBase)
                    );
                }
            }
        }

        return error.response as AxiosResponse<any>;
    }
);

instance.interceptors.request.use(
    (config) => {            
        axios.defaults.headers.common['Referrer-Policy'] = 'strict-origin-when-cross-origin';
        axios.defaults.headers.common['Permissions-Policy'] = "geolocation=(self), autoplay=(self)";
        var googleFontsUrl = "https://fonts.googleapis.com";
        var googleFontsCdn = "https://fonts.gstatic.com";
        var googletagmanager = "https://www.googletagmanager.com";    
        var googleSourceUrl = "https://www.google-analytics.com";       
        var quickSightUrl = "https://eu-west-1.quicksight.aws.amazon.com";

        axios.defaults.headers.common['Content-Security-Policy'] = `default-src 'self' 'unsafe-eval'; script-src-elem 'self' 'unsafe-eval' ${googletagmanager} ${googleSourceUrl} 'nonce-${cspNonce}'; img-src 'self' data: blob:;media-src 'self' 'unsafe-inline'; style-src-elem 'self' 'unsafe-inline' ${ googleFontsUrl } ${ googleFontsCdn }; font-src 'self' ${ googleFontsUrl } ${ googleFontsCdn }; connect-src ${ apiUrlBase } ${portalUriBase};frame-src 'self' ${quickSightUrl};`;

        return config;
    }
);


export default instance;
